<template>
  <div>
    <el-dialog
      :title="'Chọn khoản lập hóa đơn học phí: ' + titleInfoAdd"
      :visible.sync="isOpenSelectRevenueByGroupDialog"
      :empty-text="textTable"
      width="1200px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="1vh"
    >
      <el-table
        ref="multipleTable"
        :empty-text="textTable"
        highlight-current-row
        :data="listPayment"
        :cell-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
        :max-height="320"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column type="index" fixed label="STT" width="80" align="center"></el-table-column>

        <el-table-column label="Tên khoản" prop="fnPackage.name" min-width="180" align="left">
          <template v-slot:default="scope">
            <span>{{ scope.row.nameKt }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Số lượng" align="center" width="100">
          <template v-slot:default="scope">
            <span>{{ formatQuantity(scope.row.quantityKt) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Đơn giá" align="right" width="150">
          <template v-slot:default="scope">
            <span>{{ scope.row.priceKt | formatCurrency }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Giảm giá" align="right" width="150">
          <template v-slot:default="scope">
            <span>{{ scope.row.discountKt | formatCurrency }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Thành tiền" align="right" width="150">
          <template v-slot:default="scope">
            <span>{{ scope.row.moneyKt | formatCurrency }}</span>
          </template>
        </el-table-column>
      </el-table>
      <br />

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" :loading="loadingButton" mini @click="submitForm()">
          <i class="el-icon-circle-check" />
          <span>Tiếp tục</span>
        </el-button>

        <el-button type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close" />
          <span>{{ $t('button.close') }}</span>
        </el-button>
      </span>
    </el-dialog>

    <InvoiceCreateDialog
      :invoicePurpose="invoicePurpose"
      :isOpenInvoiceCreateDialog.sync="isOpenInvoiceCreateDialog"
      :initialItems="invoiceInitialItems"
      :kidCode="kidCode"
      :orderKidCode="orderKidCode"
      @invoice-created="handleInvoiceCreated"
      @dialog-close="isOpenInvoiceCreateDialog = false"
    />
  </div>
</template>

<script>
import moment from 'moment';
import GroupExcelService from '@/services/Finance_Kids_V2/GroupExcelService';
import InvoiceCreateDialog from '@/components/sinvoice_viettel/dialog/InvoiceCreateDialog.vue';

export default {
  name: 'SelectRevenueByGroupDialog',
  components: {
    InvoiceCreateDialog,
  },
  props: {
    isOpenSelectRevenueByGroupDialog: {
      type: Boolean,
      default: () => false,
    },
    isActivatedAccount: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      previewBillParams: {
        guiId: 'success',
        date: '',
        idKidList: '',
        collectionTurn: '',
      },
      textTable: this.$tableEmpty,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      titleInfoAdd: '',
      date: '',
      moneyPayment: 0,
      multipleSelection: '',

      kidCode: '',
      collectionTurn: 0,
      month: 0,
      year: 0,
      idGroup: null,
      activeStatus: Boolean,

      listPayment: [],
      afterMoney: 0,
      beforeMoney: 0,
      sumMoney: 0,
      collectedMoney: 0,
      moneyCheckTotal: 0,
      transactionEntry: '',
      checkStatus: Boolean,
      activePackageStatus: Boolean,
      urlOnlinePayment: null,

      dataInput: {
        idKids: Number,
        collectionTurn: 0,
        collectedMoney: 0,
        cash_money: 0,
        transfer_money: 0,
        afterMoney: 0,
        paymentType: null,
        parentPay: 'PHHS',
        date: '',
        datePayment: moment(String(new Date())).format('YYYY-MM-DD'),
        noteHistory: null,
        transferMoneyType: 'MONEY_WALLET',
        statusSendNotify: false,
      },

      cashMoney: 0,
      transferMoney: 0,
      afterMoneyThisMonth: 0,
      noteHistory: '',
      responseData: {},

      isOpenInvoiceCreateDialog: false,
      invoiceInitialItems: [],
      loadingButton: false,
      orderKidCode: "",
      invoicePurpose: "ONEKIDS_ORDER"
    };
  },
  methods: {
    tableHeaderColor() {
      return 'background-color: #78a5e7;color: #fff;font-weight: bold;';
    },
    tableRowStyle({ row }) {
      if (row.paid === 0) {
        return 'color: #F56C6C';
      }
      if (row.paid < row.money) {
        return 'color: #E6A23C';
      }
      return '';
    },
    clearData() {
      this.loadingButton = false;
      this.listPayment = [];
      this.afterMoney = 0;
      this.beforeMoney = 0;
      this.sumMoney = 0;
      this.collectedMoney = 0;
      this.moneyCheckTotal = 0;
      this.cashMoney = 0;
      this.transferMoney = 0;
      this.afterMoneyThisMonth = 0;
      this.noteHistory = '';
      this.transactionEntry = '';
      this.invoiceInitialItems = [];
      this.isOpenInvoiceCreateDialog = false;
    },
    closeDialog() {
      this.$emit('dialog-close', this.responseData);
      setTimeout(() => {
        this.clearData();
      }, 300);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getDataCashierInitialForGroup(
      idKid,
      kidCode,
      kidName,
      month,
      collectionTurn,
      orderKidCode,
      year,
      idGroup,
      activeStatus,
    ) {
      this.previewBillParams.date = this.$funcCommon.formatMY(year, month);
      this.previewBillParams.collectionTurn = collectionTurn;
      this.previewBillParams.idKidList = idKid;

      this.titleInfoAdd = `${kidName} - ${orderKidCode} - D${collectionTurn}`;
      this.dataInput.idKids = idKid;
      this.dataInput.collectionTurn = collectionTurn;
      this.kidCode = kidCode;
      this.collectionTurn = collectionTurn;
      this.month = month;
      this.year = year;
      this.idGroup = idGroup;
      this.activeStatus = activeStatus;
      this.orderKidCode = orderKidCode;

      if (month < 10) {
        this.dataInput.date = `${year}-0${month}-15`;
      } else {
        this.dataInput.date = `${year}-${month}-15`;
      }

      GroupExcelService
        .showAllPaymentForKidForGroup(kidCode, collectionTurn, month, year, idGroup)
        .then((res) => {
          this.listPayment = res.data.paymentDetails || [];
          this.$nextTick(() => {
            if (this.$refs.multipleTable && this.$refs.multipleTable.toggleAllSelection) {
              this.$refs.multipleTable.toggleAllSelection();
            }
          });
          this.afterMoney = res.data.afterMoney;
          this.sumMoney = res.data.sumMoney;
          this.collectedMoney = res.data.collectedMoney;
          this.dataInput.transferMoneyType = res.data.transferMoneyType;
          this.beforeMoney = res.data.beforeMoney;
          this.activePackageStatus = res.data.activeStatus;
          this.checkStatus = res.data.checkStatus;
          this.afterMoneyThisMonth = this.dataInput.cash_money + this.dataInput.transfer_money + this.afterMoney;
          this.urlOnlinePayment = res.data.urlOnlinePayment;
        })
        .catch(() => {
          this.$message({
            message: 'Thất bại',
            type: 'error',
          });
        });
    },
    formatQuantity(value) {
      if (value === undefined || value === null || value === '') return '--';
      const num = Number(value);
      if (!Number.isFinite(num)) return '--';
      return Number(num.toFixed(2)).toString();
    },
    submitForm() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message({ type: 'warning', message: 'Vui lòng chọn ít nhất một khoản để tiếp tục' });
        return;
      }

      const payload = this.multipleSelection.map((row) => {
        const qty = row.quantityKt !== undefined && row.quantityKt !== null && String(row.quantityKt).trim() !== ''
          ? Number(row.quantityKt)
          : (row.quantity !== undefined && row.quantity !== null && String(row.quantity).trim() !== '' ? Number(row.quantity) : 1);
        const price = row.priceKt !== undefined && row.priceKt !== null
          ? Number(row.priceKt)
          : (row.price !== undefined && row.price !== null ? Number(row.price) : 0);
        return {
          id: row.id,
          nameKt: row.nameKt || (row.fnPackage && row.fnPackage.name) || '',
          quantityKt: qty,
          priceKt: price,
          discountKt: Number(row.discountKt) || 0,
          moneyKt: row.moneyKt !== undefined && row.moneyKt !== null ? Number(row.moneyKt) : (qty * price),
          raw: row,
        };
      });

      this.$emit('select-revenue-continue', payload);

      this.invoiceInitialItems = payload;
      this.isOpenInvoiceCreateDialog = true;
    },
    handleInvoiceCreated(payload) {
      this.$emit('invoice-created', payload);
      this.isOpenInvoiceCreateDialog = false;

      this.$emit('dialog-close', this.responseData);
      setTimeout(() => {
        this.clearData();
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  word-break: break-word;
}

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-dialog__body {
  padding-bottom: 5px;
}

/deep/ .el-form-item__label {
  color: black;
}

.el-row {
  margin-top: 15px;
  padding-top: 20px;
  background: #97bee7;
  color: black;
  border-radius: 5px;
}

.input-common {
  margin-right: 5px;
}

.text-money {
  margin-bottom: 15px;
}

/deep/ .el-form-item__content {
  line-height: 0;
}

/deep/ .negative-value .el-input__inner {
  color: red;
}
</style>

